import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";

import { ProductSliderSkeletonComponent } from "@/components/Product/ProductSlider/components/skeleton/productSliderSkeleton.component";
import { ProductSliderSourceContextProvider } from "@/components/Product/ProductSlider/context/productSliderSource.context";

type ControlledProductSliderProps = {
    products: Array<Product<ProductFieldSet.ProductTile>>;
};

export const ControlledProductSlider = ({
    products,
    children
}: RequireChildrenFor<ControlledProductSliderProps>) => {
    if (isDefined(products) && isEmpty(products)) {
        return null;
    } else if (isDefined(products) && !isEmpty(products)) {
        return (
            <ProductSliderSourceContextProvider products={products}>
                {children}
            </ProductSliderSourceContextProvider>
        );
    } else {
        return <ProductSliderSkeletonComponent />;
    }
};
